import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  invoice: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 700,
  },
  tableTitle: {
    margin: '5px 0',
    color: '#FF505F',
    fontWeight: 'bold',
  },
  btn1: {
    background: '#4CAF50',
    width: '100%',
    color: 'white',
    marginTop: theme.spacing(1),
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
    '&:hover': {
      background: '#4CAF50',
    },
  },
  invoiceButton: {
    height: '285px',
    display: 'flex',
    alignItems: 'end',
  },
  border: {
    textTransform: 'capitalize',
    border: '1px solid #E0E0E0',
    color: 'rgb(0 0 0 / 54%)',
    fontSize: '16px',
    '& .MuiTableCell-root': {
      padding: '6px',
    },
  },
  grandTotal: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: 'black',
  },
  boxSizingPayment: {
    margin: '12px 0',
  },
  boxSizing: {
    margin: '12px 0',
    height: '285px',
    overflowY: 'auto',
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
}));
